



































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import * as d3 from 'd3'
import { mdiCheck } from '@mdi/js'

@Component
export default class PointHandle extends Vue {
  // props
  @Prop({ default: 0 }) readonly x!: number
  @Prop({ default: 0 }) readonly y!: number
  @Prop({ default: 300 }) readonly width!: number
  @Prop({ default: 150 }) readonly height!: number
  @Prop({ default: false }) readonly selected!: boolean
  @Prop({ default: false }) readonly selecting!: boolean
  @Prop({ default: '' }) readonly text!: string

  // local data
  radiusBackground = 17
  radiusSelect = 15
  selectionProgress = 0
  selectionInterval = 0
  selectionStartTimeout = 0

  // annotate refs type
  $refs!: {
    g: SVGGElement,
  }

  get g () {
    return d3.select<SVGGElement, unknown>(this.$refs.g)
  }
  get circumference (): number {
    return 2 * Math.PI * this.radiusSelect
  }
  get strokeDashArray (): number {
    return Math.round(this.circumference * 1000) / 1000
  }
  get strokeDashOffset (): string {
    return ((100 - this.selectionProgress) / 100) * this.circumference + 'px'
  }
  get xScale () {
    return d3
      .scaleLinear()
      .domain([0, 100])
      .range([0, this.width])
  }
  get yScale () {
    return d3
      .scaleLinear()
      .domain([0, 100])
      .range([0, this.height])
  }
  get xAtScale (): number {
    return this.xScale(this.x)
  }
  get yAtScale (): number {
    return this.yScale(this.y)
  }
  get transform (): string {
    return `translate(${this.xAtScale}, ${this.yAtScale})`
  }
  get drag () {
    return d3
      .drag<SVGGElement, unknown>()
      .on('start', this.dragStarted)
      .on('drag', this.dragged)
      .on('end', this.dragEnded)
  }

  // lifecycle hook
  mounted () {
    this.drag(this.g)
  }

  // methods
  dragStarted () {
    if (this.selecting) {
      this.toggleSelected()
    } else {
      this.g.classed('dragged', true)
      this.initSelecting()
    }
  }
  dragged () {
    if (!this.selecting) {
      this.cancelSelecting()
      this.$emit('updatexy', { x: this.x + this.xScale.invert(d3.event.dx), y: this.y + this.yScale.invert(d3.event.dy) })
      this.initSelecting()
    }
  }
  dragEnded () {
    if (!this.selecting) {
      this.cancelSelecting()
      this.g.classed('dragged', false)
    }
  }
  initSelecting () {
    this.cancelSelecting()
    this.selectionStartTimeout = window.setTimeout(() => {
      this.runSelecting()
    }, 500)
  }
  runSelecting () {
    this.selectionInterval = window.setInterval(() => {
      if (this.selectionProgress < 100) {
        this.selectionProgress += 2
      } else {
        this.commitSelected()
      }
    }, 10)
  }
  cancelSelecting () {
    clearInterval(this.selectionInterval)
    clearTimeout(this.selectionStartTimeout)
    this.selectionProgress = 0
  }
  commitSelected () {
    this.cancelSelecting()
    this.g.classed('dragged', false)
    this.$emit('select')
  }
  toggleSelected () {
    this.$emit('toggle')
  }
}
